import { render, staticRenderFns } from "./button-actions-context.vue?vue&type=template&id=53513b13"
import script from "./button-actions-context.vue?vue&type=script&setup=true&lang=js"
export * from "./button-actions-context.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports